module.exports = __webpack_public_path__ + "img/group-9.9831bfeb.svg";